export { default } from "./VideoSkeleton.jsx";
